import React, { useState } from "react";
import styles from "./WarningZoneList.module.css";
import EditIcon from "../../Icons/EditIcon";
import { useWarningZoneContext } from "../../../contexts/WarningZoneContext";
import Btn from "../../Btn/Btn";
import PlusIcon from "../../Icons/PlusIcon";
import { useMapDisplayContext } from "../../../contexts/MapDisplayContext";
import {useSidebarContext} from "../../../contexts/SidebarContext";

const WarningZoneList: React.FC = () => {
    const { warningZones} = useWarningZoneContext();
    const {setContentType,setChosenWarningZoneId: setWarningZoneBeingEditedId} = useSidebarContext();
    const now = Date.now();
    const zoneKeys = Object.keys(warningZones ?? {}).filter(
        key => warningZones[key].status != 3 && new Date(warningZones[key].endTime).getTime() > now
    );
    const [openKey, setOpenKey] = useState<string | null>(null);
    const { action, zoomLevel } = useMapDisplayContext();

    return (
        <>
            <div className={styles["warning-zone-list-header"] + " text"}>
                <h6 className={"text fw-bold " + styles["warning-zone-title"]}>Vùng cảnh báo</h6>
                <Btn
                    className={styles["right-btn"] + " " + styles["new-warning-zone-btn"] + " text"}
                    title="Tạo vùng cảnh báo"
                    onClick={()=>{setWarningZoneBeingEditedId("zone_001");setContentType("warningZoneUpdateForm"); }}
                >
                    <PlusIcon />
                </Btn>
            </div>
            <div className={styles["warning-zone-list"]+" styled-scrollbar"} id="warningZoneList">
                {zoneKeys.length == 0 ? (
                    <div className={styles["warning-zone-item"]}>Chưa có vùng cảnh báo nào</div>
                ) : (
                    zoneKeys.map(key => {
                        const zone = warningZones[key];
                        const isFuture = new Date(zone.startTime).getTime() > now;
                        const isOutOfDate = new Date(zone.endTime).getTime() < now;
                        return (
                            <div
                                className={
                                    styles["warning-zone-item"] 
                                }
                                id={key}
                                key={key}
                                onClick={() => {
                                    setOpenKey(prev => (prev == key ? null : key));
                                    action.setView( zone.centerLat, zone.centerLon, zoomLevel );
                                    action.clickWarningZoneMarker(key);
                                }}
                            >
                                <div className={styles["warning-zone-item-name"] + " text-large position-relative text-truncate p-2"}>
                                    {zone.name}
                                </div>
                                <p className={styles["warning-zone-item-time"] + " text"}>
                                    <span
                                        className={
                                            "text badge " + (isFuture ? "bg-primary" : isOutOfDate ? "bg-secondary" : "bg-success")
                                        }
                                        title={isFuture ? "Chưa hiệu lực" : isOutOfDate ? "Hết hiệu lực" : "Còn hiệu lực"}
                                    >
                                        {new Date(zone.startTime).toLocaleString()} - {new Date(zone.endTime).toLocaleString()}
                                    </span>
                                </p>
                                <div className={(openKey == key ? styles["extra-info-open"] : styles["extra-info"])}>
                                    <hr />
                                    <div className="d-flex justify-content-end gap-2">
                                        <Btn
                                            className={"text"}
                                            title="Sửa vùng cảnh báo"
                                            onClick={e => {
                                                e.stopPropagation();
                                                setWarningZoneBeingEditedId(key);
                                                setContentType("warningZoneUpdateForm");
                                            }}
                                        >
                                            <EditIcon />
                                        </Btn>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </>
    );
};

export default WarningZoneList;
